import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import NavBar from './components/NavigationBar/NavBar';
import BottomNav from './components/NavigationBar/BottomNav';
import Home from './components/Home/Home';
import About from './components/About/About';
import Projects from './components/Projects/Project';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  const [loading, setLoading] = useState(true);
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [cursorHover, setCursorHover] = useState(false);
  const [cursorInFooter, setCursorInFooter] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  // Custom cursor tracking
  useEffect(() => {
    const handleMouseMove = (e) => {
      setCursorPos({ x: e.clientX, y: e.clientY });
      setCursorInFooter(!!e.target.closest('footer'));
    };

    const handleMouseOver = (e) => {
      if (e.target.closest('footer')) {
        setCursorInFooter(true);
      } else {
        setCursorInFooter(false);
        if (e.target.closest('a, button, .nav-link, .project-item, .menu-link')) {
          setCursorHover(true);
        } else {
          setCursorHover(false);
        }
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseover', handleMouseOver);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseover', handleMouseOver);
    };
  }, []);

  return (
    <>
      {/* Custom Cursor - hidden over footer */}
      <motion.div
        className={`cursor-dot ${cursorHover ? 'hover' : ''} ${cursorInFooter ? 'hidden' : ''}`}
        animate={{
          x: cursorPos.x - 6,
          y: cursorPos.y - 6,
        }}
        transition={{ type: 'tween', duration: 0.05, ease: 'linear' }}
      />
      <motion.div
        className={`cursor-ring ${cursorHover ? 'hover' : ''} ${cursorInFooter ? 'hidden' : ''}`}
        animate={{
          x: cursorPos.x - 20,
          y: cursorPos.y - 20,
        }}
        transition={{ type: 'tween', duration: 0.15, ease: 'easeOut' }}
      />

      {/* Loading Screen */}
      <AnimatePresence>
        {loading && (
          <motion.div
            className="loader"
            exit={{ y: '-100%' }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          >
            <motion.h1
              className="loader-logo"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              Diana<span className="teal">.</span>
            </motion.h1>
            <motion.div
              className="loader-bar"
              initial={{ width: 0 }}
              animate={{ width: 200 }}
              transition={{ delay: 0.5, duration: 1.5, ease: 'easeInOut' }}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main App */}
      <div className="app">
        <div className="grid-bg" />
        <NavBar />
        <main>
          <Home />
          <About />
          <Projects />
          <Contact />
        </main>
        <BottomNav />
        <Footer />
      </div>
    </>
  );
}

export default App;
